import React from 'react';
import TrackingScreen from '@/pages/Tooling/TrackingScreen';
import { DIE } from '@/pages/Tooling/toolings';

export default function DieTrackingPage() {
  return <TrackingScreen tooling={DIE} />;
}
